export const getV1LabelSets = (state) =>
  state.jsonApiEntities && state.jsonApiEntities['label-sets']
export const getLabels = (state) => state.labels
export const getLabelSets = (state) => state.label_set
